"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.converter = void 0;
const _ = __importStar(require("lodash"));
const uuid_1 = require("uuid");
const common_1 = require("@finley-technologies/common");
const tape_builder_base_1 = require("../../../types/tape-builder-base");
const conversionUtils_1 = require("../../conversionUtils");
const types_1 = require("../../operations/verify/types");
const registry_1 = require("../../registry");
const utils_1 = require("../../utils");
const types_2 = require("./types");
// splits intermediateNode into tapeNode and operationNode
const intermediateToUINodes = (tape) => {
    (0, common_1.finleyAssert)(registry_1.tapeNodes.file_generatedFundingRequest.isIntermediateRecord(tape), `intermediateToUINodes: tape is not an ${types_2.artifactType}`);
    const { id, artifactSlug, creditFacilitySlug } = tape;
    const { tapeDescription, lenderVerificationConfig, fundingSubmissionComponentsArtifactSlug, } = tape.configuration;
    const tapeNode = {
        metadata: {
            tapeBuilderNodeId: id,
            tapeBuilderNodeType: types_2.nodeType,
        },
        configuration: {
            artifactSlug,
            creditFacilitySlug,
            description: tapeDescription,
            fundingSubmissionComponentsArtifactSlug,
        },
    };
    const operationNode = lenderVerificationConfig
        ? {
            metadata: {
                tapeBuilderNodeId: (0, uuid_1.v4)(),
                tapeBuilderNodeType: types_1.nodeType,
            },
            configuration: {
                description: lenderVerificationConfig.description,
                borrowerEligibilityResultsArtifactSlugs: lenderVerificationConfig.borrowerEligibilityResultsArtifactSlugs,
                borrowerNumbersArtifactSlug: lenderVerificationConfig.borrowerNumbersArtifactSlug,
            },
        }
        : null;
    return {
        operationNode,
        tapeNode,
    };
};
// converts UI nodes to intermediate records.
// returns new record and old record ids to be replaced.
const uiNodesToIntermediate = (params) => {
    const { graph, node } = params;
    (0, common_1.finleyAssert)(registry_1.tapeNodes.file_generatedFundingRequest.isNode(node), `nodeType mismatch: was expecting:${types_2.nodeType}, found: ${node.metadata.tapeBuilderNodeType}`);
    const { fundingSubmissionComponentsArtifactSlug } = node.configuration;
    const { operationNode, srcTapes } = (0, conversionUtils_1.getOperationAndTapes)({
        node,
        graph,
    });
    const verificationFlow = !!operationNode;
    let lenderVerificationConfig;
    if (verificationFlow) {
        const bbrNode = srcTapes.find(({ metadata }) => metadata.tapeBuilderNodeType ===
            registry_1.tapeNodes.file_generatedBorrowingBaseReport.nodeType);
        (0, common_1.finleyAssert)(bbrNode, 'uiNodesToIntermediate: bbrNode is null for fundingRequest');
        (0, common_1.finleyAssert)(registry_1.operationNodes.operation_verify.isNode(operationNode), 'uiNodesToIntermediate: operationNode is not a verify operation');
        // we expect at least 3 inputs to the verify operation
        // 1. borrowing base report
        // 2. borrower eligibility results (at least 1, since there needs to be 1 for each loan product)
        // 3. borrower numbers
        (0, common_1.finleyAssert)(srcTapes.length >= 3, `srcNodes.length:${srcTapes.length} < 3`);
        const { borrowerNumbersArtifactSlug, borrowerEligibilityResultsArtifactSlugs, } = operationNode.configuration;
        // we must also find the borrower numbers and borrower eligibility results in srcnodes
        const borrowerNumbersNode = srcTapes.find((srcNode) => (0, registry_1.getArtifactSlugForTapeNode)(srcNode) === borrowerNumbersArtifactSlug);
        (0, common_1.finleyAssert)(borrowerNumbersNode, 'borrowerNumbersNode missing as input to verify node');
        (0, common_1.finleyAssert)(_.size(borrowerEligibilityResultsArtifactSlugs) > 0, 'borrowerEligibilityResultsArtifactSlugs missing slugs for loan product(s)');
        const borrowerEligibilityResultsArtifactSlugStrings = _.map(borrowerEligibilityResultsArtifactSlugs, (slugString) => slugString);
        const borrowerEligibilityResultsNodes = srcTapes.filter((srcNode) => borrowerEligibilityResultsArtifactSlugStrings.includes((0, registry_1.getArtifactSlugForTapeNode)(srcNode)));
        (0, common_1.finleyAssert)(borrowerEligibilityResultsNodes.length ===
            _.size(borrowerEligibilityResultsArtifactSlugs), `borrowerEligibilityResultsNode missing input(s) to verify node. Expected ${_.size(borrowerEligibilityResultsArtifactSlugs)} inputs but received ${borrowerEligibilityResultsNodes.length}`);
        // we need to travel back to find receivable response tape
        const receivableResponseTapes = (0, utils_1.getSourceNodes)({
            node: bbrNode,
            graph,
        }).filter(({ metadata }) => metadata.tapeBuilderNodeType ===
            registry_1.tapeNodes.file_generatedReceivableResponseTape.nodeType);
        (0, common_1.finleyAssert)(receivableResponseTapes.length === 1, `FundingRequest Node: Expected 1 input node of type file_generatedReceivableResponseTape. but received ${receivableResponseTapes.length}`);
        const receivableResponseTapeNode = receivableResponseTapes[0];
        const receivableResponseTapeArtifactSlug = (0, registry_1.getArtifactSlugForTapeNode)(receivableResponseTapeNode);
        const borrowingBaseReportArtifactSlug = (0, registry_1.getArtifactSlugForTapeNode)(bbrNode);
        // extract lender verification config from operation node
        lenderVerificationConfig = {
            description: operationNode.configuration.description,
            receivableResponseTapeArtifactSlug: (0, tape_builder_base_1.asArtifactSlugRef)(receivableResponseTapeArtifactSlug),
            borrowingBaseReportArtifactSlug: (0, tape_builder_base_1.asArtifactSlugRef)(borrowingBaseReportArtifactSlug),
            borrowerNumbersArtifactSlug,
            borrowerEligibilityResultsArtifactSlugs,
        };
    }
    const { artifactSlug, creditFacilitySlug, description: tapeDescription, } = node.configuration;
    const record = {
        id: node.metadata.tapeBuilderNodeId,
        artifactDocumentId: params.artifactDocumentId,
        type: registry_1.tapeNodes.file_generatedFundingRequest.artifactType,
        artifactSlug,
        creditFacilitySlug,
        loanProductSlug: null,
        externalFilename: null,
        configuration: {
            tapeDescription,
            lenderVerificationConfig,
            fundingSubmissionComponentsArtifactSlug: (0, tape_builder_base_1.asArtifactSlugRef)(fundingSubmissionComponentsArtifactSlug),
        },
    };
    return {
        record,
        operationNode,
    };
};
exports.converter = {
    artifactType: types_2.artifactType,
    nodeType: types_2.nodeType,
    intermediateToUINodes,
    uiNodesToIntermediate,
};
//# sourceMappingURL=converter.js.map